import React from 'react';
import ComplaintsBoard from './ComplaintBoard';

const PendingComplaints = () => (
    <ComplaintsBoard
        statusFilter="pending"
        title="Pending Complaints"
        subtitle="Complaints awaiting action"
    />
);

export default PendingComplaints;